import React, {useState, useEffect} from 'react';
import PropTypes from 'prop-types';
import Modal from 'react-modal';
import cx from 'classnames';

import Button, {ButtonTypes, ButtonSizes} from '../../components/ButtonNew';
import CalendlyWidget from '../../components/CalendlyWidget';
import {useAnalytics} from '../../hooks';
import {calendlyPageView, calendlyConfirmBooking} from '../../constants/calendly';
import {XIcon} from '../../components/svg';

const CoachAvailabilityModal = ({
  isOpen, onClose, calendlyURL, coach,
}) => {
  const {tracker} = useAnalytics();
  const [loading, setLoading] = useState(true);
  const [blocked, setBlocked] = useState(false);

  const isSpecificCalendlyEvent = (e, eventType) => e.data.event && e.data.event === eventType;
  const calendlyListener = (e) => {
    if (isOpen && isSpecificCalendlyEvent(e, calendlyPageView)) {
      setLoading(false);
      tracker.coachViewAvailability({coach: coach.slug});
    } else if (isOpen && isSpecificCalendlyEvent(e, calendlyConfirmBooking)) {
      tracker.coachSelectAvailability({coach: coach.slug});
      setBlocked(true);
    }
  };

  const handleClose = () => {
    setBlocked(false);
    onClose();
  };

  useEffect(() => {
    if (isOpen) {
      window.addEventListener('message', calendlyListener);
      return () => window.removeEventListener('message', calendlyListener);
    }
    return undefined;
  }, [isOpen]);

  return (
    <Modal
      overlayClassName="fixed inset-0 bg-black bg-opacity-20 flex justify-center items-center z-10"
      className={cx('flex w-full max-w-3xl rounded-xl outline-none z-20', {
        'bg-white h-auto': blocked,
        'h-screen': !blocked,
      })}
      onRequestClose={handleClose}
      isOpen={isOpen && !!calendlyURL}
    >
      {blocked ? (
        <div className="px-10 pt-10 pb-8">
          <div className="text-center">
            <h2 className="text-xl font-extrabold text-black tracking-tight sm:text-2xl">
              Book now to reserve this space
            </h2>
            <p className="mt-4 mb-2 mx-auto max-w-2xl text-base text-gray-600">
              To continue booking your coaching session, please go back
              and purchase sessions first. You&rsquo;ll be able to
              finish scheduling after payment.
            </p>
            <Button
              size={ButtonSizes.LARGE}
              buttonType={ButtonTypes.SECONDARY}
              onClick={handleClose}
              className="mt-4"
            >
              Continue booking
            </Button>
          </div>
        </div>
      ) : (
        <>
          <CalendlyWidget href={calendlyURL} />
          <button
            type="button"
            aria-label="Close"
            className="md:hidden absolute top-1 left-1"
            onClick={handleClose}
          >
            <XIcon className="text-gray-300" />
          </button>
        </>
      )}
    </Modal>
  );
};

CoachAvailabilityModal.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
};

export default CoachAvailabilityModal;
